import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/utils/api';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.login(formData.username, formData.password);
      localStorage.setItem('token', response.data.access_token);
      toast.success('Inicio de sesión exitoso');
      
      if (response.data.user.role === 'admin') {
        navigate('/admin/departments');
      } else if (response.data.user.role === 'personal') {
        navigate('/intranet');
      } else {
        navigate('/guard/pending');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4"
      style={{
        backgroundImage: 'url(/assets/bg.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-black/50" />
      
      <div className="relative w-full max-w-md">
        <div className="bg-white/95 backdrop-blur-md rounded-lg shadow-2xl p-8">
          <div className="flex justify-center mb-6">
            <img src="/assets/logo.jpg" alt="Proesa" className="h-20" />
          </div>
          
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-2 uppercase tracking-tight">Acceso al Sistema</h1>
          <p className="text-center text-gray-600 mb-8 text-sm">Personal autorizado</p>
          
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="username" className="text-sm font-medium text-gray-700 mb-1.5 block uppercase tracking-wide">Usuario</Label>
              <Input
                id="username"
                data-testid="username-input"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                placeholder="Ingrese su usuario"
                className="h-11 border-gray-300 focus:border-[#DC143C] focus:ring-[#DC143C]"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm font-medium text-gray-700 mb-1.5 block uppercase tracking-wide">Contraseña</Label>
              <Input
                id="password"
                data-testid="password-input"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                placeholder="Ingrese su contraseña"
                className="h-11 border-gray-300 focus:border-[#DC143C] focus:ring-[#DC143C]"
                required
              />
            </div>

            <Button
              type="submit"
              data-testid="login-button"
              disabled={loading}
              className="w-full bg-[#DC143C] hover:bg-[#B91C1C] text-white font-medium uppercase tracking-wide py-3 flex items-center justify-center gap-2 active:scale-95 transition-transform"
            >
              <LogIn className="h-5 w-5" />
              {loading ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-sm text-gray-600 hover:text-[#DC143C] transition-colors">
              ← Volver al registro de visitantes
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
